import React from "react";
import "../../styles/ticket.scss";

interface TicketFilterProps {
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
}

const TicketFilter: React.FC<TicketFilterProps> = ({ activeFilter, setActiveFilter }) => {
  const filters = ["ALL", "TO PAY", "PAID", "COMPLETED", "CANCELLED"];

  return (
    <div className="ticket-filters">
      {filters.map((filter) => (
        <button
          key={filter}
          className={`filter-btn ${activeFilter === filter ? "active" : ""}`}
          onClick={() => setActiveFilter(filter)}
        >
          {filter}
        </button>
      ))}
    </div>
  );
};

export default TicketFilter;
